import Vue from 'vue'
// import axios from 'axios'
import App from './App.vue'
import store from './store'
import router from './router'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/css/common.css"
import "@/assets/scss/variable.scss"
import {byte2Auto, promisShow, byte2GB} from "@/utils/common"
import VueClipBoard from 'vue-clipboard2'
import SSO from '@/cas/sso.js'


//event bus
import eventBus from "@/utils/eventBus.js"

Vue.use(eventBus)

Vue.use(VueClipBoard);

//iserver服务头
import {iserverLayerHeader, iserverHeader,mediaView,mediaDown} from "@/utils/config"

Vue.prototype.iserverLayerHeader = iserverLayerHeader
Vue.prototype.iserverHeader = iserverHeader
Vue.prototype.mediaView = mediaView
Vue.prototype.mediaDown = mediaDown

Vue.config.productionTip = false
//byte转MB公共方法
Vue.prototype.byte2Auto = byte2Auto

Vue.prototype.byte2GB = byte2GB

//权限显隐公共方法
Vue.prototype.promisShow = promisShow

//国际化语言包
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('@/assets/lang/zh.js'),
    'en': require('@/assets/lang/en.js'),
  }
});
//supermap-leaflet样式包
import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'
import '@supermap/iclient-leaflet'

// import 'leaflet/dist/leaflet'
//element-ui库
const language = window.localStorage.getItem('language')
if (language) {
  if (language === 'zh') {
    Vue.use(ElementUI)
  }
  if (language === 'en') {
    Vue.use(ElementUI, {locale})
  }
} else {
  window.localStorage.setItem('language', 'zh')
  Vue.use(ElementUI)
}


//cas验证
SSO.init()

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
